export const districtDiagnosticIntroSteps = (isDistrict: boolean = false) => [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#schoolFilter',
    intro: 'Select a school from the dropdown to view WordFlight Diagnostic data for the selected school(s).',
  },
  {
    element: '#printButton',
    intro: isDistrict
      ? 'Click here to print the WordFlight Diagnostic report for the selected school(s).'
      : 'Click here to print the WordFlight Diagnostic data for the selected Diagnostic page.'
  },
  {
    element: '.report',
    intro: isDistrict
      ? 'Diagnostic is where you can view student Diagnostic data (Pre-, Mid-, and Post-Diagnostic) for the selected school(s).'
      : 'The Diagnostic page is where you can view student Diagnostic data (Pre-, Mid-, and Post-Diagnostic) for the school.'
  },
  {
    element: '.district-report-header-group',
    intro: 'Select (Automatic) Word Recognition or Decoding (Grades 5 and Up Only) to view the specific automatic word recognition or decoding data from the WordFlight Diagnostic.'
  },
  {
    element: '#district-report-diagnostic-progress',
    intro: isDistrict
      ? 'Select which Diagnostics to compare from the Compare Tests dropdown. Then see which number of students and percentage of students moved and stayed in the same risk categories for the selected test comparison and school(s).'
      : 'Select which Diagnostics to compare from the Compare Tests dropdown. Then see which number of students and percentage of students moved and stayed in the same risk categories for the selected test comparison.'
  },
  {
    element: '#performanceChart',
    intro: isDistrict
      ? 'See the number of students and percentage of students in each risk category for each Diagnostic assessment (Pre-, Mid- and Post-) for the selected school(s).'
      : 'See the number of students and percentage of students in each risk category for each Diagnostic assessment (Pre-, Mid-, and Post-).'
  },
  {
    element: '#makingGains',
    intro: isDistrict
      ? 'See the percentage of students who showed an increase between the Diagnostic administrations for the selected school(s).'
      : 'See the percentage of students who showed an increase between the Diagnostic administrations.'
  },
  {
    element: '#improvement',
    intro: isDistrict
      ? 'Select which Diagnostics to compare with the Compare Tests dropdown. See the number of students within each Scale Score Improvement category for the selected test comparison and school(s).'
      : 'Select which Diagnostics to compare with the Compare Tests dropdown. See the number of students within each Scale Score Improvement category for the selected test comparison.'
  }
];
